/* =============================================================================
 * coachEntry: coach vs family on /login and /signup (KGH-795)
 * -----------------------------------------------------------------------------
 * The URL alone decides the mode: ?coach=1 is the coach page, no param is the
 * family page. Nothing is read from storage, so the mode never sticks and the
 * AudienceSwitch on both pages always shows the truth.
 * ========================================================================== */

export const COACH_SETUP_PATH = '/coach/signup';

/**
 * The store app can sign up a coach. Until it can, a coach on a phone stays in
 * the browser: no "Open in the app" on invites or after email verification.
 * PROMOTION FLIP: set true once an app with COACH_SIGNUP_OPEN = true is live.
 */
export const COACH_APP_OPEN = false;

export function isCoachEntry(searchParams: URLSearchParams): boolean {
  return searchParams.get('coach') === '1';
}

/** '/login' or '/login?coach=1', and the same for '/signup'. */
export function authPath(base: '/login' | '/signup', coach: boolean): string {
  return coach ? `${base}?coach=1` : base;
}

/**
 * Coach mode: send this tab to coach setup after Google, Apple or email
 * sign-in. A more specific /coach destination already saved is kept.
 */
export function rememberCoachSetup(): void {
  try {
    if (!(sessionStorage.getItem('postLoginRedirect') || '').startsWith('/coach')) {
      sessionStorage.setItem('postLoginRedirect', COACH_SETUP_PATH);
    }
  } catch {
    /* storage blocked: sign-in still lands on the quickstart, which offers the coach choice */
  }
}

/** Family mode: drop a saved /coach destination so a family sign-in never lands in the coach flow. */
export function forgetCoachSetup(): void {
  try {
    if ((sessionStorage.getItem('postLoginRedirect') || '').startsWith('/coach')) {
      sessionStorage.removeItem('postLoginRedirect');
    }
  } catch {
    /* nothing to forget */
  }
}
